/* eslint-disable */
export default {
  pageTitle: 'Panna score',
  shortContent: "Use our FREE AI-powered platform to tailor your resume for a specific job role and make yourself stand out from the competition!",
  invalidResumeFormat: 'Invalid file format',
  resumeSizeError: 'size more than 5mb',
  saveJdPopupTitle: 'Save Job Description',
  saveJdInputLabel: 'Please enter Job Description name',
}